module.exports = __webpack_public_path__ + "afb922f9f0454fe25819df7e7e1c0547.pdf";